import { ref } from 'vue';

export type tokenKeys =
	| 'authToken'
	| 'resetPasswordToken'
	| 'invalidUserToken'
	| 'mergeToken'
	| 'activationToken'
	| 'notActivatedFcUserToken'
	| 'franceConnectToken'
	| 'chatbotToken';

export const token = ref(localStorage.getItem('authToken'));

export const chatbotToken = ref(localStorage.getItem('chatbotToken'));

export function setAuthToken(newToken: string) {
	localStorage.setItem('authToken', newToken);
	token.value = newToken;
}

export function setChatbotToken(newToken: string) {
	localStorage.setItem('chatbotToken', newToken);
	chatbotToken.value = newToken;
}

export function setToken(key: tokenKeys, newToken: string) {
	localStorage.setItem(key, newToken);
}

export function getToken(key: tokenKeys) {
	return localStorage.getItem(key);
}

export function removeToken(key: tokenKeys) {
	localStorage.removeItem(key);
}

export function removeAllTokens() {
	Object.keys(localStorage).forEach(key => {
		if (key.toLowerCase().includes('token')) {
			localStorage.removeItem(key);
		}
	});

	token.value = '';
	chatbotToken.value = '';
}
